module.exports = __webpack_public_path__ + "img/media (22).5d3a5e94.png";